<template>
  <div class="m-0 pt-1 mx-auto">
    <div
      class="h3 gilmer text-azul-oscuro text-uppercase mt-2 px-3 px-lg- font-weight-light text-center"
    >
      {{ texto }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["texto"]
};
</script>



// WEBPACK FOOTER //
// src/components/generales/Titulo.vue